import * as Types from '../constants/actionTypes';

const initState = {
    programStageInputs: [],
    programRequestTypes: [],
    programRequestStages: [],
    requestStages: [],
    portalStageStatusList: [],
    programRequestTypesSequence: [],
    listAllPortalStageStatus: [],
}
export default (state = initState, action) => {
    switch (action.type) {
        case Types.PROGRAM_REQUEST_TYPES_LIST:
            return {
                ...state,
                programRequestTypes: action.programRequestTypes
            }
        case Types.ADDED_PACKAGE_INSTRUCTION_DOCUMNET:
            return {
                ...state,
                addedPackageInstrictionDoc: action.addedDoc
            }
        case Types.PACKAGE_INSTRUCTION_ERROR:
            return {
                ...state,
                packageInstructionError: action.error
            }
        case Types.PROGRAM_REQUEST_TYPES_SEQUENCE:
            return {
                ...state,
                programRequestTypesSequence: action.programRequestTypesSequence
            }

        case Types.REQUEST_TYPES_ADDED:
            state.programRequestTypes.push(action.newProgramRequestTypes)
            return {
                ...state
            }
        case Types.REQUEST_TYPES_DELETED:
            state.programRequestTypes.splice(action.deletedRequestTypesIndex, 1)
            return {
                ...state
            }
        case Types.PROGRAM_REQUEST_STAGES_LIST:
            return {
                ...state,
                programRequestStages: action.programRequestStages
            }
        case Types.ADDED_PROGRAM_REQUEST_STAGE:
            state.programRequestStages.push(action.addedProgramRequestStage)
            return {
                ...state
            }
        case Types.DELETE_PROGRAM_REQUEST_STAGE:
            state.programRequestStages.splice(action.deleteIndex, 1)
            return {
                ...state
            }
        case Types.PROGRAM_STAGE_DIRCETION_CHANGE:
            const leftStageData = state.programRequestStages[action.sourceIndex]
            const rightStageData = state.programRequestStages[action.sourceIndex + 1]
            leftStageData.sequence = action.rightInfo.sequence
            rightStageData.sequence = action.leftInfo.sequence

            state.programRequestStages.splice(action.sourceIndex, 1, rightStageData);
            state.programRequestStages.splice(action.sourceIndex + 1, 1, leftStageData)
            return {
                ...state
            }
        case Types.PROGRAM_STAGE_QRCODE_ACCESS_LEVEL:
            state.programRequestStages[action.stageIndex].isQRCodeUser = action.isQRCodeUser
            return {
                ...state
            }
        case Types.REQUEST_STAGES:
            return {
                ...state,
                requestStages: action.requestStages
            }
        case Types.PROGRAM_PROCESS_ERROR:
            return {
                ...state,
                programProcessError: action.programProcessError
            }
        /* Functionalities for Program Stage Input Fields */
        case Types.PROGRAM_PROCESS_REQUEST_STAGE_INPUT_DATA:
            return {
                ...state,
                programStageInputs: action.programStageInputs
            }
        case Types.PROGRAM_PROCESS_REQUEST_STAGE_ERROR:
            return {
                ...state,
                programProcessRequestStageError: action.programProcessRequestStageError
            }
        case Types.PROGRAM_PROCESS_REQUEST_STAGE_ADDED_INPUT_FIELD:
            return {
                ...state,
                programStageInputs: [...state.programStageInputs, action.programStageNewInputField]
            }
        case Types.PROGRAM_PROCESS_REQUEST_STAGE_UPDATED_INPUT_FIELD:
            const existStateInput = state.programStageInputs
            if (existStateInput) {
                existStateInput[action.upIndex] = action.programStageUpdatedInputField
            }
            return {
                ...state,
                programStageInputs: existStateInput
            }
        case Types.PROGRAM_PROCESS_REQUEST_STAGE_DELETED_INPUT_FIELD:
            return {
                ...state,
                programStageInputs: state.programStageInputs.filter(item => item.id !== action.payload.id)
            }

        /* Program Stage Status Reducers */
        case Types.PROGRAM_PROCESS_REQUEST_STAGE_STATUS_ERROR:
            return {
                ...state,
                programRequestStageStatusError: action.programRequestStageStatusError
            }
        case Types.PROGRAM_STAGE_STATUS_LIST:
            return {
                ...state,
                portalStageStatusList: action.portalStageStatusList
            }
        case Types.ALL_PORTAL_STAGE_STATUS:
            return {
                ...state,
                listAllPortalStageStatus: action.listAllPortalStageStatus
            }
        case Types.PROGRAM_STAGE_STATUS_ADDED:
            state.portalStageStatusList.push(action.addedProgramStageStatus)
            
            return {...state}
        case Types.PROGRAM_STAGE_STATUS_DELETED:
                state.portalStageStatusList.splice(action.deletedIndex,1);
            return {
                ...state
            }
        case Types.UPDATE_PROGRAM_STAGE_STATUS:
            const existingStateInfo = state.portalStageStatusList[action.updateIndex]
            let finalStateInfo = action.updatedProgramStageStatus
            if(finalStateInfo) {
                finalStateInfo.statusInfo = existingStateInfo.statusInfo
            }
            state.portalStageStatusList.splice(action.updateIndex,1,finalStateInfo)
            return {
                ...state
            }
        /* Program Stage Status Reducers End */
        default:
            return state
    }
}